import './App.scss';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import { connect } from "react-redux";
import { isLogin, setUserData, setCustomerData, setWallet, setPermission, setBill, setProfit, setRoute, setWhiteLabelData } from "./actions";
import { setBotcharge } from './actions/botChargeAction';
import { LocalStorageService } from './services/LocalStorage';
import AxiosService from './services/APIService';
import webSocketService from './services/websocketService';
import ProtectedRoute from './security/ProtectedRoute';

// Layouts
import AdminLayout from './components/AdminLayout';
import UserLayout from './components/UserLayout';
import WLLayout from './components/WLLayout';

// Auth pages
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import RegistrationReference from './pages/RegistrationReference';
import WlRegister from './pages/WlRegister';

// Admin pages
import AdminDashboard from './pages/AdminDashboard';
import Users from './pages/Users';
import PendingUser from './pages/PendingUser';
import CloseUser from './pages/CloseUser';
import Brokers from './pages/Brokers';
import Server from './pages/Server';
import Team from './pages/Team';
import Profit from './pages/Profit';
import UserProfile from './pages/UserProfile';
import DepositReport from './pages/DepositReport';
import WithdrawReport from './pages/WithdrawReport';
import BotReport from './pages/BotReport';
import NoteReq from './pages/NoteReq';
import SettingReq from './pages/SettingReq';
import BotFile from './pages/BotFile';
import Announcement from './pages/Announcement';
import QrCode from './pages/QrCode';
import BotSettings from './pages/BotSettings';

// White Label Admin pages
import AWhiteLabelDashboard from "./pages/whiteLabelAdmin/Dashboard";
import WhiteLabels from './pages/whiteLabelAdmin/WhiteLabels';
import PendingWhiteLabel from './pages/whiteLabelAdmin/PendingWhiteLabel';
import CloseWhiteLabel from './pages/whiteLabelAdmin/CloseWhiteLabel';
import WLUserList from './pages/whiteLabelAdmin/WLUserList';
import WLPendingUserList from './pages/whiteLabelAdmin/WLPendingUserList';
import WLCloseUserList from './pages/whiteLabelAdmin/WLCloseUserList';
import WLDepositReport from './pages/whiteLabelAdmin/WLDepositReport';
import WLWithdrawReport from './pages/whiteLabelAdmin/WLWithdrawReport';
import WLBotChargeReport from './pages/whiteLabelAdmin/WLBotChargeReport';
import WLProfit from './pages/whiteLabelAdmin/WLProfit';
import WLBotFile from './pages/whiteLabelAdmin/WLBotFile';
import WLAnnouncement from './pages/whiteLabelAdmin/WLAnnouncement';
import WLQrCode from './pages/whiteLabelAdmin/WLQrCode';
import WLBroker from './pages/whiteLabelAdmin/WLBroker';
import WLServer from './pages/whiteLabelAdmin/WLServer';
import WLLevel from './pages/whiteLabelAdmin/WLLevel';
import WLBillReport from './pages/whiteLabelAdmin/WLBillReport';

// White Label pages
import WhiteLabelProfile from './pages/whiteLabel/WLProfile';
import Leads from './pages/whiteLabel/Leads';
import Inquiry from './pages/whiteLabel/Inquiry';
import PayBill from './pages/whiteLabel/PayBill';
import EmailInfo from './pages/EmailInfo';

// Pip-Grid pages
import AAdminDashboard from './pages/PipGrid/Dashboard';
import UserRequest from './pages/PipGrid/UsersRequests';
import UsersList from './pages/PipGrid/UsersList';
import LeadsList from './pages/PipGrid/LeadsList';
import PipGridNotes from './pages/PipGrid/Notes';
import Setting from './pages/PipGrid/Setting';
import PromoCode from './pages/PipGrid/PromoCode';
import AffiliateRequest from './pages/PipGrid/Affiliate/AffiliateRequest';
import AffiliateUsers from './pages/PipGrid/Affiliate/AffiliateUsers';
import PayoutRequest from './pages/PipGrid/Payout/PayoutRequest';
import PayoutHistory from './pages/PipGrid/Payout/PayoutHistory';

// Make My Profit pages
import MakeMyProfitDashboard from './pages/MakeMyProfit/Dashboard';
import MakeMyProfitUserRequest from './pages/MakeMyProfit/UsersRequests';
import MakeMyProfitUsersList from './pages/MakeMyProfit/UsersList';
import MakeMyProfitLeadsList from './pages/MakeMyProfit/LeadsList';
import MakeMyProfitNotes from './pages/MakeMyProfit/Notes';
import MakeMyProfitServer from './pages/MakeMyProfit/Server';

// User pages
import UserRegistration from './pages/UserRegistration';
import UserDashboard from './pages/UserDashboard';
import DepositHistory from './pages/DepositHistory';
import WithdrawHistory from './pages/WithdrawHistory';
import BotCharge from './pages/BotCharge';
import BotPerformance from './pages/BotPerformance';
import {getLoginRoute} from './utils/commonFunc';
import Exhibition from './pages/whiteLabel/ExhibitionForm';
import ExhibitionForm from './pages/whiteLabel/ExhibitionForm';
import MakeMyProfitInquiryForm from './pages/whiteLabel/MakeMyProfitInquiryForm';
import WhiteLabelInquiryForm from './pages/whiteLabel/WhiteLabelInquiryForm';
import ExhibitiomList from './pages/whiteLabel/ExhibitiomList';
import PipGridInquiry from './pages/PipGrid/PipGridInquiry';
import MakeMyProfitInquiry from './pages/MakeMyProfit/MakeMyProfitInquiry';
import LeadsInquiry from './pages/whiteLabelAdmin/LeadsInquiry';
import AdminExhibitionForm from './pages/whiteLabelAdmin/AdminExhibitionForm';
import AdminExhibitiomList from './pages/whiteLabelAdmin/AdminExhibitiomList';
import WLRejectUserList from './pages/whiteLabelAdmin/WLRejectUserList';

// Route configurations
const adminRoutes = [
  { path: '/home', component: AdminDashboard },
  { path: '/users', component: Users },
  { path: '/pending-users', component: PendingUser },
  { path: '/close-user', component: CloseUser },
  { path: '/deposit-report', component: DepositReport },
  { path: '/withdraw-report', component: WithdrawReport },
  { path: '/botcharge-report', component: BotReport },
  { path: '/broker', component: Brokers },
  { path: '/user-profile', component: UserProfile },
  { path: '/server', component: Server },
  { path: '/profit', component: Profit },
  { path: '/note-request', component: NoteReq },
  { path: '/setting-request', component: SettingReq },
  { path: '/bot-file', component: BotFile },
  { path: '/announcement', component: Announcement },
  { path: '/qr-code', component: QrCode },
  { path: '/bot-performance', component: BotSettings },
];

const whiteLabelAdminRoutes = [
  { path: '/white-label/home', component: AWhiteLabelDashboard },
  { path: '/white-label/list', component: WhiteLabels },
  { path: '/white-label/pending', component: PendingWhiteLabel },
  { path: '/white-label/close', component: CloseWhiteLabel },
  { path: '/white-label/user-list', component: WLUserList },
  { path: '/white-label/pending-user', component: WLPendingUserList },
  { path: '/white-label/reject-user', component: WLRejectUserList },
  { path: '/white-label/close-user', component: WLCloseUserList },
  { path: '/white-label/deposit-report', component: WLDepositReport },
  { path: '/white-label/withdraw-report', component: WLWithdrawReport },
  { path: '/white-label/botcharge-report', component: WLBotChargeReport },
  { path: '/white-label/profit', component: WLProfit },
  { path: '/white-label/bot-file', component: WLBotFile },
  { path: '/white-label/announcement', component: WLAnnouncement },
  { path: '/white-label/qr-code', component: WLQrCode },
  { path: '/white-label/broker', component: WLBroker },
  { path: '/white-label/server', component: WLServer },
  { path: '/white-label/level', component: WLLevel },
  { path: '/white-label/bill-report', component: WLBillReport },
  { path: '/white-label/leads-inquiry', component: LeadsInquiry },
  { path: '/white-label/exhibition', component: AdminExhibitiomList },

];

const whiteLabelRoutes = [
  { path: '/wl/home', component: AdminDashboard },
  { path: '/wl/users', component: Users },
  { path: '/wl/pending-users', component: PendingUser },
  { path: '/wl/close-user', component: CloseUser },
  { path: '/wl/deposit-report', component: DepositReport },
  { path: '/wl/withdraw-report', component: WithdrawReport },
  { path: '/wl/botcharge-report', component: BotReport },
  { path: '/wl/user-profile', component: UserProfile },
  { path: '/wl/broker', component: Brokers },
  { path: '/wl/profit', component: Profit },
  { path: '/wl/note-request', component: NoteReq },
  { path: '/wl/setting-request', component: SettingReq },
  { path: '/wl/announcement', component: Announcement },
  { path: '/wl/my-bill', component: PayBill },
  { path: '/wl/my-profile', component: WhiteLabelProfile },
  { path: '/wl/inquiry', component: Inquiry },
  { path: '/wl/exhibition', component: ExhibitiomList },
  { path: '/wl/email-info', component: EmailInfo },
];

const pipGridRoutes = [
  { path: '/pip-Grid/home', component: AAdminDashboard },
  { path: '/pip-Grid/users-request', component: UserRequest },
  { path: '/pip-Grid/users-list', component: UsersList },
  { path: '/pip-Grid/leads-list', component: LeadsList },
  { path: '/pip-Grid/notes', component: PipGridNotes },
  { path: '/pip-Grid/setting', component: Setting },
  { path: '/pip-Grid/promo-code', component: PromoCode },
  { path: '/pip-Grid/affiliate-request', component: AffiliateRequest },
  { path: '/pip-Grid/affiliate-users', component: AffiliateUsers },
  { path: '/pip-Grid/payout-request', component: PayoutRequest  },
  { path: '/pip-Grid/payout-history', component:  PayoutHistory },
  { path: '/pip-Grid/inquiry', component:  PipGridInquiry },
];

const makeMyProfitRoutes = [
  { path: '/make-my-profit/home', component: MakeMyProfitDashboard },
  { path: '/make-my-profit/users-request', component: MakeMyProfitUserRequest },
  { path: '/make-my-profit/users-list', component: MakeMyProfitUsersList },
  { path: '/make-my-profit/leads', component: MakeMyProfitUsersList },
  { path: '/make-my-profit/notes', component: MakeMyProfitNotes },
  { path: '/make-my-profit/server', component: MakeMyProfitServer },
  { path: '/make-my-profit/leads-inquiry', component: MakeMyProfitInquiry },
];

const userRoutes = [
  { path: '/dashboard', component: UserDashboard },
  { path: '/deposit', component: DepositHistory },
  { path: '/withdraw', component: WithdrawHistory },
  { path: '/bot-charge', component: BotCharge },
  { path: '/bot-performance', component: BotPerformance },
  { path: '/profile', component: UserProfile },
];

function App({ isLogin, setUserData, setWhiteLabelData, setWallet, setPermission, user,customer, setBill, setProfit, setBotcharge, setRoute, setCustomerData }) {
    const location = useLocation();
    const axiosService = new AxiosService();
    
    useEffect(() => {
        const token = LocalStorageService.getItem("userToken");
        document.title = 'AIFXBRAIN V1.0';
        
        if (token) {
            checkAuthentication();
        } else {
            isLogin(false);
            setUserData(null);
        }
        
        webSocketService.connect(process.env.REACT_APP_SOCKET_URL);
    }, []);
    
    useEffect(() => {
        setRoute(location.pathname);
    }, [location]);

    const checkAuthentication = async () => {
        try {
            const res = await axiosService.get("/auth/me");
            isLogin(true);
            setUserData(res?.user);
            
            if (res?.user?.role === "CUSTOMER") {
                setCustomerData(res?.customer);
                setWallet(res?.wallet);
                setBill(res?.bill);
                setProfit(res?.totalProfit);
                setBotcharge(res?.botCharge);
            }
            
            if (res?.user?.role === "WHITE_LABEL") {
                setWhiteLabelData(res?.white_label);
                setBill(res?.bill);
            }
            
            if (res?.user?.role === "SUBADMIN") {
                setPermission(res?.permission);
            }
        } catch (error) {
            isLogin(false);
            setUserData(null);
            LocalStorageService.removeItem("userToken");
        }
    };

    const navigationTo = () => {
        const userData = LocalStorageService.getItem("user");
        const urlParams = new URLSearchParams(window.location.search);
        const tokenParam = urlParams.get('token');
        const token = tokenParam || LocalStorageService.getItem("userToken");
        
        if (userData && token) {
            if (userData?.role === "ADMIN" && !tokenParam) {
                return "/home";
            } else if (userData?.role === "ADMIN" && tokenParam) {
                return `/dashboard?token=${tokenParam}`;
            } else {
                return "/dashboard";
            }
        }
        
        return getLoginRoute({...user, ...customer});
    };

    // Helper function to generate routes
    const generateRoutes = (routes, layout, role) => {
        return routes.map(route => (
            <Route 
                key={route.path}
                path={route.path} 
                element={<ProtectedRoute layout={layout} component={route.component} role={role} />} 
            />
        ));
    };

    return (
        <Routes>
            {/* Public routes */}
            <Route path="/login/:role" Component={Login} />
            <Route path="/reset-password" Component={ResetPassword} />
            <Route path="/reference" Component={RegistrationReference} />
            <Route path='/wl-registration' Component={WlRegister} />
            <Route path='/leads' element={<Leads />} />
            <Route path='/white_label/inquiry' element={<WhiteLabelInquiryForm />} />
            <Route path='/white_label/exhibition' element={<ExhibitionForm />} />
            <Route path='/make-my-profit/inquiry' element={<MakeMyProfitInquiryForm />} />
            <Route path='/admin/white_label/exhibition' element={<AdminExhibitionForm />} />
            <Route path='/registration' Component={UserRegistration} />


            {/* Admin routes */}
            {generateRoutes(adminRoutes, AdminLayout, 'admin')}
            
            {/* Team route - only for admin */}
            {user?.role === "ADMIN" && (
                <Route path='/team' element={<ProtectedRoute layout={AdminLayout} component={Team} role='admin' />} />
            )}

            {/* White Label Admin routes */}
            {generateRoutes(whiteLabelAdminRoutes, AdminLayout, 'admin')}

            {/* White Label routes */}
            {generateRoutes(whiteLabelRoutes, WLLayout, 'white_label')}

            {/* Pip-Grid routes */}
            {generateRoutes(pipGridRoutes, AdminLayout, 'admin')}

            {/* Make My Profit routes */}
            {generateRoutes(makeMyProfitRoutes, AdminLayout, 'admin_or_mmp_admin')}

            {/* User routes */}
            {generateRoutes(userRoutes, UserLayout, 'user')}

            {/* Default route */}
            <Route path='/' element={<Navigate to={navigationTo()} />} />
        </Routes>
    );
}

const mapStateToProps = ({ login }) => {
    const { user, customer} = login;
    return { user, customer };
};

const mapDispatchToProps = {
    setUserData,
    isLogin,
    setCustomerData,
    setWallet,
    setPermission,
    setBill,
    setProfit,
    setBotcharge,
    setRoute,
    setWhiteLabelData
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
